module.exports = __webpack_public_path__ + "img/theme-c.e1a032c3.png";